<form (submit)="triggerSearch(type)" [formGroup]="form">
    <!-- <p class="h1 mb-3 pre-wrap text-center">Log a new Job or Register Equipment</p> -->
    <p class="welcome-title h1 mb-3 pre-wrap text-center">{{ "JobNew.Welcome" | translate:translateParams }}</p>
    <div class="card-deck">

        <!-- Job -->
        <ng-container *ngIf="type===REG_TYPES.JOB">
            <div class="card" formGroupName="newJob" *ngIf="!customer && (canLogNewJob || !isPublic)">
                <div class="card-header py-2">
                    <div class="d-flex justify-content-between">
                        <h4 class="card-title my-0 flex-grow-1" translate="JobNew.LogNewHeader"></h4>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <p class="col-12 line-breaker" *ngIf="isPublic">{{ 'JobNew.EnterAllDetails' | translate2: 'unescape' }}</p>

                        <ng-container *hasTranslation="'Contact.FirstName'">
                            <abi-form-field *ngIf="isPublic" label="Contact.FirstName" cols="col-md-12">
                                <input type="text" formControlName="firstname" id="firstname" data-cy="search-firstname"/>
                            </abi-form-field>
                        </ng-container>

                        <ng-container *hasTranslation="'Contact.FullName'">
                            <abi-form-field label="Contact.FullName" cols="col-md-12">
                                <input type="text" formControlName="fullname" id="fullname" data-cy="search-fullname"/>
                            </abi-form-field>
                        </ng-container>

                        <ng-container *hasTranslation="'Contact.LastName'">
                            <abi-form-field *ngIf="isPublic" label="Contact.LastName" cols="col-md-12">
                                <input type="text" formControlName="lastname" id="lastname" data-cy="search-lastname"/>
                            </abi-form-field>
                        </ng-container>

                        <!-- <ng-container *hasTranslation="'JobNew.Address'">
                            <abi-form-field label="JobNew.Address" cols="col-md-12">
                                <input type="text" formControlName="address" id="address" data-cy="search-address"/>
                            </abi-form-field>
                        </ng-container> -->

                        <ng-container *hasTranslation="'JobNew.Telephone'">
                            <abi-form-field label="JobNew.Telephone" [errors]="formErrors.telephone" cols="col-md-12">
                                <abi-phone-input *ngIf="withCountrySelector" formControlName="telephone"></abi-phone-input>
                                <input *ngIf="!withCountrySelector" type="text" [mask]="phoneMask" formControlName="telephone" data-cy="search-telephone" />
                            </abi-form-field>
                        </ng-container>
                        <!-- <abi-form-field label="JobNew.Telephone" [errors]="formErrors.telephone" cols="col-md-12">
                            <abi-phone-input *ngIf="withCountrySelector" formControlName="telephone"></abi-phone-input>
                            <input *ngIf="!withCountrySelector" type="text" [mask]="phoneMask" formControlName="telephone" data-cy="search-telephone" />
                        </abi-form-field> -->

                        <ng-container *hasTranslation="'JobNew.Email'">
                            <abi-form-field label="JobNew.Email" [errors]="formErrors.email" cols="col-md-12">
                                <input type="email" formControlName="email" data-cy="search-email" />
                            </abi-form-field>
                        </ng-container>
                        <!-- <abi-form-field label="JobNew.Email" [errors]="formErrors.email" cols="col-md-12">
                            <input type="email" formControlName="email" data-cy="search-email" />
                        </abi-form-field> -->

                        <ng-container *hasTranslation="'Customer.CustomerID'">
                            <abi-form-field label="Customer.CustomerID" [errors]="formErrors.customerId" cols="col-md-12">
                                <input type="text" formControlName="customerId" data-cy="search-customerid"/>
                            </abi-form-field>
                        </ng-container>
                        <!-- <abi-form-field label="Customer.CustomerID" [errors]="formErrors.customerId" cols="col-md-12">
                            <input type="text" formControlName="customerId" data-cy="search-customerid"/>
                        </abi-form-field> -->

                        <ng-container *hasTranslation="'Contact.IDNumber'">
                            <abi-form-field label="Contact.IDNumber" [errors]="formErrors.idNumber" cols="col-md-12">
                                <input type="text" [mask]="idNumberMask" formControlName="idNumber" data-cy="search-idnumber"/>
                            </abi-form-field>
                        </ng-container>
                        <!-- <abi-form-field label="Contact.IDNumber" [errors]="formErrors.idNumber" cols="col-md-12">
                            <input type="text" [mask]="idNumberMask" formControlName="idNumber" data-cy="search-idnumber"/>
                        </abi-form-field> -->

                        <ng-container *hasTranslation="'JobNew.Serial'">
                            <abi-form-field label="JobNew.Serial" [errors]="formErrors.serial" cols="col-md-12">
                                <input type="text" formControlName="serial" data-cy="search-serial" />
                            </abi-form-field>
                        </ng-container>
                    </div>
                </div>
                <div class="card-footer py-2 text-right">
                    <button
                        type="submit"
                        [disabled]="form.get('newJob').invalid || customerSearchBusy"
                        class="btn btn-primary"
                        data-cy="search-lookup">
                        <i class="fas" [ngClass]="{'fa-search': !customerSearchBusy, 'fa-spinner fa-pulse': customerSearchBusy}"></i>
                        &nbsp;{{ 'JobNew.Lookup' | translate }}</button>
                </div>
            </div>

            <div *ngIf="!customer && isPublic" class="card" formGroupName="job">
                <div class="card-header py-2">
                    <h4 class="card-title my-0" translate="JobNew.QueryHeader"></h4>
                </div>
                <div class="card-body">
                    <div class="row">
                        <p class="col-12" translate="JobNew.EnterQueryDetails">
                        </p>

                        <ng-container *hasTranslation="'Job.JobID'">
                            <abi-form-field label="Job.JobID" cols="col-md-12">
                                <input type="text" formControlName="jobId" id="query-jobId" />
                            </abi-form-field>
                        </ng-container>

                        <ng-container *hasTranslation="'JobNew.Telephone'">
                            <abi-form-field label="JobNew.Telephone" cols="col-md-12">
                                <abi-phone-input *ngIf="withCountrySelector" formControlName="telephone"></abi-phone-input>
                                <input *ngIf="!withCountrySelector" type="text" [mask]="phoneMask" formControlName="telephone" id="query-telephone" data-cy="query-telephone" />
                            </abi-form-field>
                        </ng-container>
                    </div>
                </div>
                <div class="card-footer py-2 text-right">
                    <a [routerLink]="jobLink()" class="btn btn-primary"><i class="fas fa-search"></i> {{ 'JobNew.Search' | translate }}</a>
                </div>
            </div>
        </ng-container>

        <!-- Registration -->
        <ng-container *ngIf="type===REG_TYPES.REGISTRATION">
            <div class="card" formGroupName="customerSearch">
                <div class="card-header py-2">
                  <h4 class="card-title my-0" translate="CustomerNew.QueryHeader"></h4>
                </div>
                <div class="card-body">
                    <div class="row">
                        <p class="col-12" translate="CustomerNew.EnterQueryDetails"> </p>
                        <abi-form-field label="Contact.FirstName" cols="col-md-12">
                            <input type="text" formControlName="firstname" id="firstname" />
                        </abi-form-field>

                        <abi-form-field *ngIf="isPublic" label="Contact.LastName" cols="col-md-12">
                            <input type="text" formControlName="lastname" id="lastname" />
                        </abi-form-field>

                        <abi-form-field label="JobNew.Telephone" [errors]="formErrors.telephone" cols="col-md-12">
                            <input type="text" [mask]="phoneMask" formControlName="telephone" />
                        </abi-form-field>
                    </div>
                </div>
                <div class="card-footer py-2">
                    <button type="submit" [disabled]="form.get('customerSearch').invalid"
                      class="btn btn-primary float-right"><i class="fas fa-search"></i> {{ 'CustomerNew.Lookup' | translate }}</button>
                </div>
            </div>
        </ng-container>
    </div>
</form>

<div
    *ngIf="false && searched && type===REG_TYPES.JOB && form.get('newJob').value"
    class="alert alert-primary mt-3"
    role="alert"
    id="newRequest"
>
    <span [innerHtml]="'JobNew.CustomerNotFound' | translate"></span>&nbsp;
    <!-- Create a new Job and Register a new Customer -->
    <a
        class="btn btn-primary"
        [routerLink]="['create', form.get('newJob').value]"
        translate="Register New Customer"
    ></a>
    <!-- CODE SMELL: The 'isPublic' condition may fall away as the Technician should be able to REGISTER A PRODUCT too -->
    <ng-container *ngIf="canRegisterNewCustomer && isPublic">
    <!-- <ng-container> -->
        <!-- Register a Customer Only -->
        &nbsp;or&nbsp;
        <a
            class="btn btn-primary"
            [routerLink]="['register', form.get('newJob').value]"
            translate="New Product Registration"
        ></a>
    </ng-container>
</div>

<div class="card mt-3" *ngIf="searched && !customerSearchBusy && customers.length && !customer">
    <div class="card-header py-2">
        <h4 #customerSearchResult class="card-title my-0" translate="JobNew.MatchingCustomers"></h4>
    </div>
    <div class="card-body">
        <!-- <abi-spinner *ngIf="customerSearchBusy" class="m-3"></abi-spinner> -->
        <ng-container *ngIf="!customerSearchBusy">
            <ng-container *ngIf="customers.length">
                <!-- <p>{{ 'JobNew.MatchingCustomersBlurb' | translate }}</p> -->
                <p>We found records matching your Details, you can use the Customer Record if you have provided complete information.</p>
                <div class="table-responsive">
                <table
                    abi-table
                    [columns]="columns"
                    [rows]="customers"
                    class="table table-striped table-sm mb-0 customer-list table-fixed"
                    [hiddenColumns]="true"

                >
                    <ng-template td="contacts.0" let-row="row" let-value="value">
                        {{ value | contact }}<br />
                        <ng-container *hasTranslation="'Contact.Mobile'">{{ value?.mobile }}<br /></ng-container>
                        <ng-container *hasTranslation="'Address.PostalCode'">{{ row.addresses[0]?.postalCode }}</ng-container>
                    </ng-template>

                    <!-- last col - link -->
                    <ng-template td="link" let-row="row" let-value="value">
                        <ng-container *ngIf="type==='registration'">
                            <!-- go direct to Reg Form -->
                            <a
                                class="btn btn-sm btn-primary"
                                *ngIf="row.id"
                                [routerLink]="[
                                    registerRoute,
                                    selectedCustomerJobValues(row)
                                ]"
                                translate="JobNew.SelectCustomer"
                            ></a>
                        </ng-container>
                        <ng-container *ngIf="type==='job'">
                            <!-- go to Jobs listing -->
                            <a
                                class="btn btn-sm btn-primary"
                                *ngIf="row.id"
                                href=""
                                (click)="selectCustomer(row, confirm)"
                                translate="JobNew.SelectCustomer"
                            ></a>
                        </ng-container>
                    </ng-template>
                    <ng-template th="">

                    </ng-template>
                </table>
            </div>
            </ng-container>
            <ng-container *ngIf="!customers.length">
                <p class="mb-0 align-center">{{'JobNew.NoCustomerResults' | translate }}</p>
            </ng-container>
        </ng-container>
    </div>
</div>

<div class="card mt-3" *ngIf="searched && !customerSearchBusy && !customer">
    <div class="card-header py-2">
        <h4 #customerSearchResult class="card-title my-0" translate="Register as New Customer"></h4>
    </div>
    <div class="card-body">
        <p class="mb-0 align-center">If your details are not listed above, then Register with the button(s) below:</p>
    </div>
    <div class="card-footer py-2 text-right">
        <ng-container *ngIf="type===REG_TYPES.JOB">
            <a
                class="btn btn-primary"
                [routerLink]="['create', createNewJobValues()]"
                translate="JobNew.CreateJob"
                data-cy="search-job-new"
            ></a>
            <!-- CODE SMELL: The 'isPublic' condition may fall away as the Technician should be able to REGISTER A PRODUCT too -->
            <ng-container *ngIf="canRegisterNewCustomer && isPublic">
                <!-- Register a Customer Only -->
                &nbsp;or&nbsp;
                <a
                    class="btn btn-primary"
                    [routerLink]="[registerRoute, createNewJobValues()]"
                    translate="JobNew.RegisterMachine"
                ></a>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="type===REG_TYPES.REGISTRATION">
            <a
                class="btn btn-primary float-right"
                [routerLink]="[registerRoute, createNewCustomerValues()]"
                translate="JobNew.RegisterMachine"
            ></a>
        </ng-container>
    </div>
</div>

<div class="card" *ngIf="customer">
    <div class="card-header py-2">
        <h4 class="card-title my-0" translate="JobNew.Details"></h4>
        <div class="row mt-2">
            <div class="col">
                {{ customer.id }}<br/>
                {{ customer.contacts[0] | contact }}<br/>
                {{ customer.companyName || customer.contacts[0]?.companyName || customer.contacts[0]?.note }}
            </div>
            <div class="col">
                <div class="line-breaker">
                    {{ customer.addresses[0] | address }}
                </div>
            </div>
            <div class="col">
            </div>
        </div>
    </div>

    <div class="card-header">
        <ul ngbNav #nav="ngbNav" class="nav-tabs card-header-tabs" [destroyOnHide]="false" >
            <li ngbNavItem="existingJobs">
                <a ngbNavLink>Customer Jobs ({{ customerJobs.length }})</a>
                <ng-template ngbNavContent>
                    <abi-spinner *ngIf="jobSearchBusy"></abi-spinner>
                    <table class="table table-striped table-sm mb-0" *ngIf="!jobSearchBusy">
                        <thead class="thead-light">
                            <tr>
                                <th translate="Job.JobID" class="narrow-column"></th>
                                <th translate="Job.Logged" class="date"></th>
                                <th translate="Job.StatusID" class="code-5"></th>
                                <th translate="Job.Machine"></th>
                                <th translate="Machine.Serial" class="w-20"></th>
                                <th translate="Job.TypeID" class="code-5"></th>
                                <th translate="Job.Closed" class="text-center code-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let result of customerJobs">
                                <td>
                                    <a [routerLink]="jobLinkRow(result)">{{ result.jobId }}</a>
                                </td>
                                <td>{{ result.loggedDate | date }}</td>
                                <td>{{ result.statusId }}</td>
                                <td><span class="d-block w-99 text-truncate">{{ result.modelId | lookupvalue : 'modelmaster'}}</span></td>
                                <td>{{ result.serialNumber }}</td>
                                <td>{{ result.typeId }}</td>
                                <td class="text-center">
                                    {{ result.closed ? 'Yes' : 'No'}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-template>
            </li>
            <li ngbNavItem="appliances" *ngIf="showAppliances">
                <a ngbNavLink>Customer {{ "Customer.Machines" | translate }} {{ customerAppliances.length ? '('+ customerAppliances.length +')' : '' }}</a>
                <ng-template ngbNavContent>

                    <abi-spinner *ngIf="applianceSearchBusy"></abi-spinner>
                    <table class="table table-striped table-sm mb-0" *ngIf="!applianceSearchBusy">
                        <thead class="thead-light">
                            <tr>
                                <th translate="Machine.ModelID"></th>
                                <th translate="Machine.Serial"></th>
                                <th translate="Machine.MachineName"></th>
                                <th translate="Contract.Title"></th>
                                <th translate="Status"></th>
                                <th translate="" class="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let appliance of customerAppliances">
                                <td>
                                    {{ appliance.modelId }}
                                </td>
                                <td>
                                    {{ appliance.serialNumber }}
                                </td>
                                <td>
                                    {{ appliance.name | truncate: 35 }}
                                </td>
                                <td>
                                    <span class="" [abiLookupdisplay]="getContractType(appliance.machineId)" listName="CodeContractType"></span>
                                </td>
                                <td>
                                    {{ appliance.statusId === "I" ? "Inactive" : "Active" }}
                                </td>
                                <td class="text-right">
                                    <!-- LOG JOB on EXISTING CUSTOMER AND MACHINE -->
                                    <a
                                        *ngIf="appliance.statusId !== 'I'"
                                        class="btn btn-primary btn-sm"
                                        [routerLink]="[
                                            'create',
                                            existingCustomerJobValues(appliance)
                                        ]"
                                        translate="JobNew.CreateJobOnMachine"
                                    ></a>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-template>
            </li>
        </ul>
    </div>
    <div class="card-body job-list" [ngbNavOutlet]="nav"></div>

    <div class="card-footer py-2 text-right" *ngIf="customer?.id">
        <div class="d-flex justify-content-between">
            <div class="footer-left">
                <button type="button" class="btn btn-primary" (click)="returnToList()"><i class="fas fa-arrow-left"></i>&nbsp;Return</button>
            </div>
            <div class="footer-right">

                <ng-container *ngIf="type===REG_TYPES.JOB">
                    <a
                        class="btn btn-primary"
                        [routerLink]="[
                        'create',
                        existingCustomerJobValues()
                    ]"
                        translate="JobNew.CreateJob"
                    ></a>
                    <!-- CODE SMELL: The 'isPublic' condition may fall away as the Technician should be able to REGISTER A PRODUCT too -->
                    <ng-container *ngIf="canRegisterNewCustomer && isPublic">
                        <!-- Register a Customer Only -->
                        &nbsp;or&nbsp;
                        <a
                            class="btn btn-primary"
                            [routerLink]="[
                                registerRoute,
                                existingCustomerJobValues()
                            ]"
                            translate="JobNew.RegisterMachine"
                        ></a>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="type===REG_TYPES.REGISTRATION">
                    <a
                        class="btn btn-primary float-right"
                        [routerLink]="[
                            registerRoute,
                            existingCustomerJobValues()
                        ]"
                        translate="JobNew.RegisterMachine"
                    ></a>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template #confirm>
    <h4 mat-dialog-title>Verify contract</h4>
    <mat-dialog-content>
        <p *ngIf="inactiveContracts">Customer has inactive contracts.</p>
        <p *ngIf="overdueContracts">Customer contracts are overdue ({{ overdueContracts | number : '1.2' }}).</p>
        Continue?
    </mat-dialog-content>
    <mat-dialog-actions>
        <button
            type="button"
            [mat-dialog-close]="false"
            mat-button
            translate="System.No"
        ></button>
        <button
            type="button"
            [mat-dialog-close]="true"
            mat-button
            translate="System.Yes"
        ></button>
    </mat-dialog-actions>
</ng-template>


<!-- <pre>
    {{ route.snapshot.params | json }}
</pre> -->
